import React, { useContext, useEffect } from 'react';
import { Checkbox } from 'antd';
import { ModelContext } from '../../metadata/ModelSource';
import {DriversAndVehiclesDataReportContext} from '../../../context/DriversAndVehiclesDataReportProvider';
const CheckboxGroup = Checkbox.Group;

export function VehiclesCheckbox({ defaultValue, onChange, formAttribute,lineCd }) {
  const applicationModel = useContext(ModelContext);
  let { selectedRisks, dataPrefillRisks, setDataPrefillRisks, setSelectedRisks } = useContext(DriversAndVehiclesDataReportContext);

  let risks = applicationModel.getValue(`lines{lineCd:${lineCd}}.risks`) || [];

  useEffect(() => {
    dataPrefillRisks = risks.filter(d=>d.id.indexOf('Prefill') !== -1);
    dataPrefillRisks = dataPrefillRisks.map(d=> ({...d, 'status' : 'Prefill'}));

    setDataPrefillRisks(dataPrefillRisks);
  }, [applicationModel]);


  const onRiskChange = selectedValues => {
    risks = risks.map(r=>{
      if(selectedValues.includes(r.id)){
        return {...r, 'status': 'Active'};
      }else {
        return {...r,'status': 'Deleted'};
      }
    })

    selectedRisks = risks.filter(r=>selectedValues.includes(r.id))
    setSelectedRisks(selectedRisks);

    applicationModel.setValue(`lines{lineCd:${lineCd}}.risks`,risks);
  };

  return (
      dataPrefillRisks && dataPrefillRisks.length > 0 ? <CheckboxGroup
          style={{ marginTop: '2.75em',display:"flex", flexDirection:"column"}}
          onChange={onRiskChange}
          options={dataPrefillRisks.map(r =>
              ({label:r.vehicle.manufacturer+" "+r.vehicle.model+", "+r.vehicle.modelYr,value:r.id}))}
          defaultValue={selectedRisks ? selectedRisks.map(r=>r.id): []}
      >
      </CheckboxGroup> : null
  );
}
